import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=3540c925&scoped=true&"
import script from "./YouTube.vue?vue&type=script&lang=js&"
export * from "./YouTube.vue?vue&type=script&lang=js&"
import style0 from "./YouTube.vue?vue&type=style&index=0&id=3540c925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540c925",
  null
  
)

export default component.exports